import { setAccessToken } from "../../Utils/authHeader";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "../../Schema/authSchema";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useMutation } from "react-query";
import { login } from "../../Services/Auth";
import { setUser } from "../../Redux/slice";
import Button from "../../Components/Button";
import { Error } from "../../Components/Modal";
import "../../styles/PremiumLogin.css";

export default function Login() {
  const navigate = useNavigate();
  
  useEffect(() => {
    const logoutMsg = sessionStorage.getItem("logoutToast");
    if (logoutMsg) {
      Error(logoutMsg);
      sessionStorage.removeItem("logoutToast");
    }
  }, []);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });
  const [showPassword, setShowPassword] = useState(false);

  const { mutate, isLoading } = useMutation((data) => login(data), {
    retry: false,
    onSuccess: (res) => {
      // console.log("Login: ", res.data);
      setAccessToken(res.data?.token);
      dispatch(setUser(res.data?.user));
      navigate("/dashboard");
    },
    onError: (err) => {
      // console.log("Login Err: ", err.response.data);
      Error(err.response.data?.message);
    },
  });

  const submit = (data) => {
    // console.log({ data });
    const loginObj = {
      email: data?.email,
      password: data?.password,
      source: "admin",
    };
    mutate(loginObj);
  };

  return (
    <section className="loginPage">
      <div className="container-fluid p-0">
        <div className="row g-0 align-items-center">
          <div className="col-lg-6 loginBgLeft d-none d-lg-flex">
            <div className="loginBgLeftPattern" style={{ backgroundImage: "url('/images/loginLeftContentBG.png')" }} />
            <div className="loginLeftContent">
              <img
                src="images/loginLogo.png"
                alt="MUVRRS Logo"
                className="img-fluid loginLogo"
              />
              <p className="loginLeftTagline">
                Empowering Logistics. <strong>Anytime. Anywhere.</strong>
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 loginBgRight">
            <div className="loginCard">
              <div className="text-center d-block d-lg-none mb-4">
                <img
                  src="images/loginLogo.png"
                  alt="MUVRRS Logo"
                  className="loginLogo img-fluid"
                />
              </div>
              <div className="formBox">
                <div className="formHeading mb-4">
                  <h2>Sign In</h2>
                  <p className="d-lg-none">Please sign in to your account</p>
                </div>
                <form
                  className="py-2"
                  onSubmit={handleSubmit(submit)}
                >
                  <div className="form-field">
                    <label htmlFor="email" className="siteLabel">
                      Email<span className="text-danger">*</span>
                    </label>
                    <div className="input-icon-wrapper">
                      <i className="fas fa-envelope input-icon-left" />
                      <input
                        type="email"
                        className="siteInput"
                        placeholder="Enter Email Address"
                        id="email"
                        {...register("email")}
                      />
                    </div>
                    {errors?.email && (
                      <span className="text-danger">
                        {errors?.email?.message}
                      </span>
                    )}
                  </div>
                  <div className="form-field">
                    <label htmlFor="password" className="siteLabel">
                      Password<span className="text-danger">*</span>
                    </label>
                    <div className="input-icon-wrapper">
                      <i className="fas fa-lock input-icon-left" />
                      <input
                        type={showPassword ? "text" : "password"}
                        className="siteInput passInput"
                        placeholder="Enter Password"
                        id="password"
                        {...register("password")}
                      />
                      <button
                        type="button"
                        className="passDisplay"
                        onClick={() =>
                          setShowPassword((showPassword) => !showPassword)
                        }
                      >
                        <i
                          className={
                            showPassword ? "fas fa-eye" : "fas fa-eye-slash"
                          }
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                    {errors?.password && (
                      <span className="text-danger">
                        {errors?.password?.message}
                      </span>
                    )}
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center">
                      <input type="checkbox" id="rememberMe" />
                      <label htmlFor="rememberMe">
                        Remember Me
                      </label>
                    </div>
                    <div>
                      <Link to="/forgot-password" title="Forgot Password" className="forgotLink">
                        Forgot Password?
                      </Link>
                    </div>
                  </div>
                  <div className="form-field mt-4 text-center">
                    <Button
                      type="submit"
                      className="siteBtn w-100 mb-3"
                      loading={isLoading}
                    >
                      SIGN IN
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
